// src/pages/CalculoHonorarios/components/FormularioTrabalho.js

import React, { useState } from 'react';
import DadosGerais from './DadosGerais';
import DadosTrabalho from './DadosTrabalho';
import PonderacoesFinais from './PonderacoesFinais';

const FormularioTrabalho = ({ 
  honorarioEditando, 
  onSalvar, 
  onCancelar, 
  loading 
}) => {
  const [formData, setFormData] = useState(honorarioEditando || {
    cod_cli: null,
    nome_cli: '',
    descricao_servico: '',
    base_total_horas: 0,
    base_valor_hora: 0,
    complexidade: '',
    complexidade_descricao: '',
    risco: '',
    risco_descricao: '',
    urgencia: '',
    urgencia_descricao: '',
    condicoes_economicas: '',
    resultados_obtidos: '',
    orientacoes_adicionais: ''
  });

  const [secaoColapsada, setSecaoColapsada] = useState({
    parte1: false,
    parte2: false,
    parte3: false
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const toggleSecao = (secao) => {
    setSecaoColapsada(prev => ({
      ...prev,
      [secao]: !prev[secao]
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.descricao_servico || !formData.descricao_servico.trim()) {
      alert('Descrição do serviço é obrigatória');
      return;
    }
    
    onSalvar(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="formulario-trabalho">
      <div className="formulario-header">
        <h2>{honorarioEditando?.id ? '✏️ Editar Honorário' : '➕ Novo Cálculo de Honorários'}</h2>
      </div>

      <div className="formulario-secoes">
        <div className={`secao-wrapper ${secaoColapsada.parte1 ? 'colapsada' : ''}`}>
          <div className="secao-toggle" onClick={() => toggleSecao('parte1')}>
            <span className="toggle-icon">{secaoColapsada.parte1 ? '▶' : '▼'}</span>
            <span>Parte 1 — Dados Gerais</span>
          </div>
          {!secaoColapsada.parte1 && (
            <DadosGerais formData={formData} onChange={handleChange} />
          )}
        </div>

        <div className={`secao-wrapper ${secaoColapsada.parte2 ? 'colapsada' : ''}`}>
          <div className="secao-toggle" onClick={() => toggleSecao('parte2')}>
            <span className="toggle-icon">{secaoColapsada.parte2 ? '▶' : '▼'}</span>
            <span>Parte 2 — Dados do Trabalho</span>
          </div>
          {!secaoColapsada.parte2 && (
            <DadosTrabalho formData={formData} onChange={handleChange} />
          )}
        </div>

        <div className={`secao-wrapper ${secaoColapsada.parte3 ? 'colapsada' : ''}`}>
          <div className="secao-toggle" onClick={() => toggleSecao('parte3')}>
            <span className="toggle-icon">{secaoColapsada.parte3 ? '▶' : '▼'}</span>
            <span>Parte 3 — Ponderações Finais</span>
          </div>
          {!secaoColapsada.parte3 && (
            <PonderacoesFinais formData={formData} onChange={handleChange} />
          )}
        </div>
      </div>

      <div className="form-actions">
        <button 
          type="submit" 
          className="action-btn save-btn"
          disabled={loading}
        >
          {loading ? '⏳ Salvando...' : '💾 SALVAR'}
        </button>
        <button 
          type="button"
          className="action-btn cancel-btn"
          onClick={onCancelar}
          disabled={loading}
        >
          ❌ CANCELAR
        </button>
      </div>
    </form>
  );
};

export default FormularioTrabalho;